module.exports = __webpack_public_path__ + "static/media/Rectangle.6e26caac.png";